export const S3_URL = 'https://cdn.chordchord.com'

export const TILE_HEIGHT = 108
export const TILE_HEIGHT_SMALL = 108
export const TILE_HEIGHT_MOBILE = 108

export const CURRENT_BIG_FEATURE = 'guitar'

export const COPYRIGHT = `©${new Date().getFullYear()} ChordChord LTD. All rights reserved`
